<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" styleClass="confirm-dialog" appendTo="body"></p-confirmDialog>

<!-- Start of Quick search common component -->
  @if(selectedTabIndex===1) {
    <app-quick-search 
      [DefaultFilterArray]="finraExceptionService.defaultFilters"
      [QuickSearchFilterArray]="quickFilterArray"
      [FilterFieldDefaultValues]="filterFieldDefaultValues"
      (updateDefaultArray)="updateDefaultArray($event)"
      (clearQuickSearch)="clearQuickSearch($event)">
    </app-quick-search>
  }
<!-- End of Quick search common component -->

<div class="col-lg-12 nopadding">
  <app-filter-panel [GridColumns]="cols" [DefaultFilterArray]="finraExceptionService.defaultFilters" [ResetLabel]="isFilterLabelReset"
    (FilterEvent)="onFilterApplyFilterEvent($event)" (FilterEventClearSymbol)="onFilterEventClearSymbol($event)"
    (FilterEventClearCode)="onFilterEventClearCode($event)">
  </app-filter-panel>
</div>

<div class="col-lg-12 nopadding">
  @if(screenLoading){
    <div class="example-loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  }

  <p-tabs class="finra-exception-tab" [value]="selectedTabIndex" (valueChange)="selectedTabIndex = $event">
    <p-tablist>
    <p-tab [value]="0">Summary</p-tab>
    <p-tab [value]="1">Details</p-tab>
     </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
         <!-- Finra Exception Summary Screen -->
          <app-finra-exception-summary
          [defaultFilters]="finraExceptionService.defaultFilters">
          </app-finra-exception-summary>
        <!-- End of Finra Exception Summary Screen -->
        </p-tabpanel>
        <p-tabpanel [value]="1">
          <!-- Finra Exception Detail Screen -->
            <div class="row excpDetail">
              @if(!dataLoadingSymbolsAndCodes){
              <div class="col-lg-12 nopadding">
                <app-symbol-panel [SymbolArray]="symbols" [CodeBlockArray]="codes" [isDisplayCodeBlock]="true" [ResetLabel]="resetLabel" [rowCount]="totalRecords"
                  [rowCountSymbol]="totalRecords" (ActiveSymbolEvent)="onActiveSymbolEvent($event)"
                  (ActiveCodeEvent)="onActiveCodeEvent($event)">
                </app-symbol-panel>
              </div>
              }
              <div class="col-lg-12 nopadding">
                @if(dataLoading){
                  <div class="example-loading-shade">
                    <mat-spinner></mat-spinner>
                  </div>
                }
        <div class="card" (mouseup)="commonColService.stopDragging()" (mouseleave)="commonColService.stopDragging()">
          <p-contextMenu #cm [model]="commonColService.menuItems" appendTo="body" styleClass="column-context-menu"></p-contextMenu>  
                <p-table #dt
                  [columns]="commonColService.selectedColumns"
                  [value]="finraExceptionService.finraExceptions"
                  [class.finratable-frozen]="commonColService.isFrozenColumns"
                  [resizableColumns]="true"
                  [lazy]="true"
                  (onLazyLoad)="loadRecordsLazy($event)"
                  sortField="symbol,firmROEID"
                  [sortOrder]="constantService.DEFAULT_SORDORDER_ASC"
                  [paginator]="true"
                [(selection)]="selectedRow"
                  appendTo="body"
                  alwaysShowPaginator="true"
                  paginatorPosition="both"
                  showCurrentPageReport="true"
                  [rows]="constantService.DEFAULT_ROWSIZE"
                  [totalRecords]="totalExceptionRecords"
                  [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS" 
                  [rowsPerPageOptions]="rowsPerPageOptions"
                  [scrollable]="true" 
                  scrollHeight="60vh"
                  [reorderableColumns]="true"
                  (onColReorder)="commonColService.onColumnsReordered($event, dt)"
                  styleClass="detailsTable">
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="columns.length">
                          {{constantService.NO_RECORDFOUND_MSG}}
                        </td>
                      </tr>
                    </ng-template>
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th id="finraExceptiontableCheckBox" style="width: 3em" pFrozenColumn
                        [frozen]= "commonColService.hasFrozenColumns()">
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                      </th>
                      @for(col of columns; track col.ui_columnname + '-'+ $index) {
                      <th [attr.id]="'col-' + col.field" pResizableColumn [pSortableColumn]="col.mappingkey"
                        [pSortableColumnDisabled]="col.ui_columnname === 'action'"
                        pFrozenColumn pReorderableColumn
                        [frozen]="col.mappingkey === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen" 
                        alignFrozen="left"
                        [style.left]="(col.mappingkey === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
                        [style.background-color]="col.frozen && !commonColService.selectedFields.includes(commonColService.getColumnField(col)) ? 'sortClass' : null"
                        [class.selected-header]="commonColService.selectedFields.includes(commonColService.getColumnField(col))"
                        (mousedown)="commonColService.onHeaderMouseDown($event, commonColService.getColumnField(col))"
                        (mouseenter)="commonColService.onHeaderMouseEnter(commonColService.getColumnField(col))"
                        (contextmenu)="commonColService.onHeaderContextMenu($event, commonColService.getColumnField(col),contextMenuItems, dt)">
                        <div class="header-cell-content">
                          <span [class.excel-cursor-span]="(col.ui_columnname | lowercase) !== 'action'"  style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{col.ui_columnname}}
                        @if(col.ui_columnname !== 'action'){
                        <p-sortIcon [field]="col.mappingkey"></p-sortIcon>
                        }
                        </span>
                        @if(col.frozen) {
                        <i class="pi pi-lock" style="font-size: 0.85rem; color: #000; margin-left: 2px;"></i>
                        }
                        </div>
                      </th>
                      }
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-ri let-columns="columns" let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="ri"
                    [ngClass]="(!rowData['errorROEID']) ?'ui-widget-newError-row':((rowData['modifiedFlag'] | lowercase)== 'u' ?
                    'ui-widget-updated-row' : (rowData['modifiedFlag'] | lowercase) == 'd' ? 
                    'ui-widget-deleted-row .ui-chkbox ' : 'ui-widget-NoUpdated-row')">
                    <td style="width: 3em;padding-left: 6px !important;" pFrozenColumn
                      [frozen]= "commonColService.hasFrozenColumns()">
                      <p-tableCheckbox  [id]="'checkbox'+ rowIndex" [value]="rowData" (click)="displayDropdownTypeBySelectedType(rowData);"></p-tableCheckbox>
                    </td> 
                    @for(col of columns; track col.ui_columnname + '-'+ $index) {
                    <td class="ui-resizable-column" style="max-width: 500px !important;"
                    pFrozenColumn
                    [frozen]="col.mappingkey === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen"
                    alignFrozen="left"
                    [style.left]="(col.mappingkey === 'modifiedFlag' ? commonColService.hasFrozenColumns() : col.frozen) ? $any(col).stickyLeft : ''"
                    [style.background-color]="selectedRow?.includes(rowData)? '#88c0eb': (col.frozen ? '#e2f0d9' : null)"  >
                        @if(col.ui_columnname === 'action'){
                        <span>
                          <span>
                            {{rowData.modifiedFlag}} 
                          </span>
                          @if(rowData.modifiedFlag !== 'G' && rowData.modifiedFlag !== 'C' && rowData.modifiedFlag !== 'F'){
                          <span>
                             @if(commonColService.hasFrozenColumns()){
                            <p-button [ngStyle]="{width: '23px'}" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" 
                            [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye" (click)="onView(rowData);" [disabled] = "selectedRow.length>=2"></p-button>
                            }
                            @else{
                            @if(selectedRow.length < 2){
                            <p-button [ngStyle]="{width: '23px'}" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" 
                            [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye" (click)="onView(rowData);"></p-button>
                            }
                          }
                            <p-button class="pi pi-xxx editIcon" or class="fa fa-xxx editIcon" matTooltip="Edit" [matTooltipShowDelay]="1000" matTooltipPosition="above"
                              appendTo="body" icon="fa fa-fw fa-edit" (click)="onEdit(rowData);">
                            </p-button>
                            @if(rowData.modifiedFlag === 'D'){
                            <ng-container>
                              <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Restore" [matTooltipShowDelay]="1000" matTooltipPosition="above"
                                appendTo="body" icon="fa fa-fw fa-undo" (click)="onRestore(rowData);"></p-button>
                            </ng-container>
                            }
                            @if(rowData.modifiedFlag !== 'D'){
                            <ng-container>
                              <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" [matTooltipShowDelay]="1000" matTooltipPosition="above"
                                appendTo="body" icon="fa fa-fw fa-trash" (click)="onDelete(rowData);"></p-button>
                            </ng-container>
                            }
                          </span>
                          }
                            <p-button class="pi pi-xxx treeViewTcon" or class="fa fa-xxx treeViewTcon" matTooltip="Parent/Child Event Tree" [matTooltipShowDelay]="1000" matTooltipPosition="above"
                              appendTo="body" icon="fa fa-fw fa-tree" [id]="'tree'+ rowIndex" (click)="onTree(rowData);"></p-button>
                            <p-button class="pi pi-xxx commentIcon" or class="fa fa-xxx commentIcon" matTooltip="Add Comment" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body"
                              icon="fa fa-fw fa-comment" [id]="'comment'+ rowIndex" (click)="addComment(rowData);"></p-button>
                            <p-button class="pi pi-xxx listIcon" or class="fa fa-xxx listIcon" matTooltip="Audit-Trail" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body"
                              icon="fa fa-fw fa-list" [id]="'audit'+ rowIndex" (click)="onAuditTrail(rowData)"></p-button>
                            @if(rowData.isEligibleToApplySuggestVal && !['D', 'G', 'F'].includes(rowData.modifiedFlag)){  
                            <p-button class="pi pi-xxx listIcon" or class="fa fa-xxx listIcon" matTooltip="Apply-Suggested-Value" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body"
                              icon="fa fa-fw fa-wrench" [id]="'applysuggested'+ rowIndex" (click)="onApplySuggest(rowData)"></p-button>
                            }
                        </span>
                        }
                        @if(col.mappingkey === 'firmROEID'){
                        <span>
                          <a class="exception-table-link" matTooltip="View ROE Details" [matTooltipShowDelay]="1000" appendTo="body" (click)="onShowROEEdit('edit',rowData,rowIndex);">{{rowData[col.db_columnname]}}</a>
                        </span>
                        }
                        @if(col.mappingkey === 'orderID'){
                        <span>
                          <a class="exception-table-link" matTooltip="View Order Details" [matTooltipShowDelay]="1000" appendTo="body" (click)="onShowOrderViewer(rowData,rowIndex);">{{rowData[col.db_columnname]}}</a>
                        </span>
                        }
                        @if(col.ui_columnname === 'type'){
                        <span>
                          @if((multiLegEventArray && multiLegEventArray.includes(rowData[col.db_columnname]))){
                          <span>
                            <a class="exception-table-link" [matTooltip]="'Num of Legs: ' + getNumberofLegs(rowData)" [matTooltipShowDelay]="1000" [matTooltipPosition]="'above'" (click)="onClickMultiLegEvent(rowIndex,rowData)" [ngStyle]="{'text-decoration':'underline', 'cursor': 'pointer'}">{{rowData[col.db_columnname]}}</a>
                          </span>
                          }
                          @if(multiLegEventArray && !(multiLegEventArray.includes(rowData[col.db_columnname]))){
                          <span>
                            {{rowData[col.db_columnname]}}
                          </span>
                          }
                        </span>
                        }
                        @if(col.mappingkey === 'caseComments'){
                        <span tooltipStyleClass="custom-tooltip" [escape]="false" [pTooltip]="getTooltipContent(rowData)">
                          {{rowData[col.db_columnname]}}
                        </span>
                        }
                        @if(col.ui_columnname === 'symbol'){
                        <div class="pull-right" [ngClass]="'displayWhitespaces'">
                          {{(rowData[col.db_columnname] ? rowData[col.db_columnname] : (rowData['optionalSymbol'] ? rowData['optionalSymbol'] : ''))}}
                        </div>
                        }
                        @if(col.ui_columnname === 'Suggested Value' && isEnabledcaisFDIDService){
                        <span>
                          <a class="cat-exception-table-link" appendTo="body" (click)="openDetails(rowData)"
                            style="color: blue;cursor: pointer;text-decoration: none;">{{checkErrorcode(rowData['failureCode'],rowData['suggestedValue'])}}</a>
                        </span>
                       }
                        @if(col.ui_columnname!=='action' && col.ui_columnname != 'Suggested Value' && col.ui_columnname !== 'symbol' && col.mappingkey !== 'firmROEID' && col.mappingkey !== 'orderID' && col.mappingkey !== 'caseComments' && col.mappingkey !== 'type'){
                        <span>
                          {{rowData[col.db_columnname]}}
                        </span>
                        }
                      </td>
                    }
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="paginatorright">
                    <!-- Create Parent Dropdown Button -->
                      <button id="createParent" name="createParent" matTooltip="Create Mass Parents" [matTooltipShowDelay]="1000" class="exportBtn exportCreateParent" 
                        (click)="onOptingCreateParentEventType()" type="button">Create Parent
                      </button>
                    <!-- End of Creating Parent Dropdown Button -->
              
                    <p-select name="newROEEntry" id="id_newROEEntry" 
                    [options]="eventList"
                    [(ngModel)]="selectedEventType"
                    placeholder="New ROE Entry"
                    (onChange)="onEventTypeChange($event)" [showClear]="true"
                    class="EventTypeDropdown">
                  </p-select>

                      @if((userService.isRoleSuperUser() || userService.isRoleFirmAdmin())){
                      <button matTooltip="Mass Correction" [matTooltipShowDelay]="1000" class="exportBtn"  
                        (click)="onShowMassCorrectionScreen()" type="button">Mass Correction
                      </button>
                      }
                      <button  matTooltip="Counterparty Report" [matTooltipShowDelay]="1000" class="exportBtn"  
                      (click)="counterpartyPartyReport()" type="button">Counterparty Report
                      </button>
                      <app-export-to-csv [gridColumns]="cols" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
                    <button  
                    [matTooltip]="this.userService.enableFileExport()?
                    'Export to temporary repair file for only one day data *(Don\'t use daterange)':'Export service is disabled'"
                    [matTooltipShowDelay]="1000"class="exportBtn"  
                      (click)="exportToJSON()" type="button">Exceptions <i class="fa fa-download" aria-hidden="true"></i> 
                      @if(isExportToJSON){
                      <img style="text-align:right" alt="ExportToJSON"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                      }
                      </button>
                    Total Records: {{totalRecords}}
                  </ng-template>
                  <ng-template pTemplate="paginatorleft">
                    Showing {{recordFrom}} to {{recordTo}} entries </ng-template>
                </p-table>
                </div>
              </div>
            </div>
        <!-- End of Finra Exception Detail Screen -->
          </p-tabpanel>
        </p-tabpanels>
        </p-tabs>
</div>

<!-- Mass Correction Update Component -->
 @if(getAppliedCodeFilter() && userService.showMassCorrection){
  <ng-container>
    <app-mass-correction 
      [totalRecords]="totalRecords" 
      [defaultFilters]="finraExceptionService.defaultFilters" 
      [massCorrectionColumns]="massCorrectionFields"
      (updateMassCorrectionField)="updateMassCorrectedField($event)">
    </app-mass-correction>
  </ng-container>
  }
<!-- End of Mass Correction Update Component -->

@if(finraExceptionService.showView){
<ng-container>
  <app-finra-exception-view 
    [finraException]="selectedRecord"  
    [fieldDictionaryList]="fieldDictionaryList">
  </app-finra-exception-view>
</ng-container>
}

@if(finraExceptionService.showEdit){
<ng-container>
  <app-finra-exception-edit 
    (closeDialog)="getFinraExceptions(false, false, true)" 
    [firmROEIDList]="firmROEIDList"
    [isMultiEdit]="isMultiEdit" 
    [finraException]="selectedRecord" 
    [correctCodeLength]="correctCodeLength" 
    [finraExceptionType]="finraExceptionType" 
    [fieldDictionaryList]="fieldDictionaryList"></app-finra-exception-edit>
</ng-container>
}
@if(this.finraExceptionService.showROEEdit){
<ng-container>
  <app-single-edit-form 
      [screenType]="'finraException'" 
      (closeDialog)="closeDialog($event)" 
      [rowData]="rowDataforDialog" 
      [index]="rowIndexForDialog" 
      [value]="actionType">
  </app-single-edit-form>
</ng-container>
}
@if(finraExceptionService.showCounterpartyReport){
<ng-container>
  <app-counterparty-party-report
  [filter]="finraExceptionService.defaultFilters" >
</app-counterparty-party-report>
</ng-container>
}

@if(this.eventTreeService.isDialogOpen){
<app-event-tree-dialog
id="finra-parent-child-event-tree"
[SelectedRow]="selectedRow"
[isTreeOpen]="this.eventTreeService.isDialogOpen"
[pageName]="ApplicationName">
</app-event-tree-dialog>
}

@if(isAuditTrail){
<app-audit-trail-dialog 
id="finra-exceptions-audit-trail" 
(closeEventDialog)="isAuditTrail = false"
[SelectedRow]="selectedRow"
[isAuditTrailOpen]="isAuditTrail"
[pageName]="ApplicationName">
</app-audit-trail-dialog>
}

<!-- DialogBox for Comment Operation -->
<!-- Exception Comment Component -->
 @if(isDisplayCommentDialog){
  <app-exception-comment 
    [selectedRow]="selectedRow" 
    [userList]="userList" 
    (closeDialog)="isDisplayCommentDialog = false" 
    (updateExceptionStatus)="updateClientDataStaus($event)">
  </app-exception-comment>
  }
<!-- End of Exception Comment Component -->

<!-- View MultiLeg Events -->
 @if(viewMultiLegEvent){
  <app-multileg-event
    id="multileg_event"
    [index]="rowIndexForDialog"
    [rowData]="rowDataforDialog"  
    [showMultiLegEvent]="viewMultiLegEvent"
    (closeMultiLegEvent)="closeMultiLegEvent($event)">
  </app-multileg-event>
  }
<!-- Create New ROE Record -->
 @if(displayNewROEDialog){
<app-new-roe-entry
[selectedEventType]="selectedEventType"
[selectedID]="selectedID"
[pageName]="'Finra-Exception'"
[reportDate]="selectedReportDate"
[existingEventType]="existingEventType"
[groupName]="groupName"
[rowData]="selectedRow"
[errorROEID]="errorROEID"
[CATReporterIMID]="CATReporterIMID"
(closeDropdown)="closeDropdown($event)" 
>
</app-new-roe-entry>
 }
<!-- End of Create New ROE Record -->

<!-- Create Parent Order Records -->
 @if(finraExceptionService.showCreateParentScreen){
  <ng-container>
    <app-create-parent 
      [pageName]="'Finra-Exception'" 
      [totalRecords]="(selectedRow.length > 0 ? selectedRow.length : totalRecords)" 
      [defaultFilters]="finraExceptionService.defaultFilters" 
      [selectedRecords]="selectedRow"
      (PostCreateParentAction)="postCreateParentAction($event)">
    </app-create-parent>
  </ng-container>
  }
<!-- End of Create Parent Order Records -->

@if(viewFDID){
  <app-view-fdid [viewFDIDOpen]="viewFDID" [displaySideBar]="displaySideBar" [selectedFDIDDetails]="selectedFDIDDetails"
  (closeDialog)="onClickCancelFDID()"></app-view-fdid>
 }
